import React from 'react';
import PlaceholderPage from '../MyBiz/PlaceholderPage';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

const UnauthorizedErrorPage: React.FC = () => {
  const emptyImage3 = require("../../assets/images/Empty3.png");
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/login")
  }

  return (
   <PlaceholderPage
          title="Unauthorized"
          emptyStateText="You will have to login to load this page."
          emptyStateImage={emptyImage3}
          actionButtons={
            <Button variant="contained" color="primary" onClick={handleGoToLogin}>
                Go to Login
            </Button>
            }
        />
  );
};

export default UnauthorizedErrorPage;
